export default __webpack_public_path__ + "static/media/vaccine.a941b739.png";